/**
 * File view component.
 * @module components/theme/View/FileView
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { useSelector } from 'react-redux';
import { Redirect, useLocation as location } from 'react-router-dom';
/**
 * File view component class.
 * @function FileView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
// User ikonoan klikatu harte ez du user lortzen
const FileView = ({ content }) => {
  const user = useSelector((state) => state.users?.user);
  //reaload page if user role is not Manager
  React.useEffect(() => {
    if (
      user?.roles?.includes('Manager') === false ||
      user?.roles === undefined
    ) {
      window.location.reload();
    }
  }, [user]);

  return (
    <>
      {user?.roles?.includes('Manager') ? (
        <Container className="view-wrapper">
          <h1 className="documentFirstHeading">
            {content.title}
            {content.subtitle && ` - ${content.subtitle}`}
          </h1>
          {content.description && (
            <p className="documentDescription">{content.description}</p>
          )}
          {content.file?.download && (
            <a href={flattenToAppURL(content.file.download)}>
              {content.file.filename}
            </a>
          )}
        </Container>
      ) : (
        <Redirect
          to={flattenToAppURL(
            content.file.download,
          )} /* to={flattenToAppURL(`${content['@id']}/@@download/file`)} */
        />
      )}
    </>
  );
};
/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
FileView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    file: PropTypes.shape({
      download: PropTypes.string,
      filename: PropTypes.string,
    }),
  }).isRequired,
};

export default FileView;
